import React from 'react';
import Button from 'components/Button';

import { ReactComponent as CheckIcon } from 'images/check-icon.svg';
import { ReactComponent as CrossIcon } from 'images/cross-icon.svg';

import styles from './DecisionButtons.module.scss';

export enum DecisionOptions {
  Yes = 'Yes',
  No = 'No',
}

interface DecisionButtonsProps {
  title?: string;
  handleContinue: (method: DecisionOptions) => void;
}

const DecisionButtons = ({ title, handleContinue }: DecisionButtonsProps) => (
  <div className={styles.mainContainer}>
    {title && <p className={styles.title}>{title}</p>}
    <div className={styles.buttonsContainer}>
      <Button onClick={() => handleContinue(DecisionOptions.No)} className={styles.button}>
        <CrossIcon />
        {DecisionOptions.No}
      </Button>
      <Button onClick={() => handleContinue(DecisionOptions.Yes)} className={styles.button}>
        <CheckIcon />
        {DecisionOptions.Yes}
      </Button>
    </div>
  </div>
);

export default DecisionButtons;
